export default "__VITE_ASSET__BsPC4WIu__"